import {ToggleDataView} from '../../types';

export const toggleDataView=()=>{
    return {
        type:ToggleDataView,
        payload:'Data'
    }
}